// extracted by mini-css-extract-plugin
var _1 = "SettingsNavItem-module__active--IiUV9";
var _2 = "SettingsNavItem-module__animateUploadProgressBarWidth--o7Qnh";
var _3 = "SettingsNavItem-module__animatedBackground--uGlk9";
var _4 = "SettingsNavItem-module__icon--vvjCX";
var _5 = "SettingsNavItem-module__item--eAiHS";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "icon", _5 as "item" }
